import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { AddressMrhComponent } from "@shared/components/offers/MRH/address-mrh/address-mrh.component";
import { TitlePjComponent } from "@shared/components/offers/PJ/title-pj/title-pj.component";
import { TitleSaComponent } from "@shared/components/offers/SA/title-sa/title-sa.component";
import { StatusCardComponent } from "@shared/components/status-card/status-card.component";
import { ID_PARAM } from "@shared/constants/route-variables.constants";
import { CONTRACTDETAILS } from "@shared/constants/route.constants";
import { Branches } from "@shared/enums/branches";
import { Policy } from "@shared/models/policy";
import { StatusConfig } from "@shared/models/status-config.model";
import { OffersTypeService } from "@shared/services/offers-type.service";
import { PolicyStatusService } from "@shared/services/policy-status.service";
import { Guid } from "guid-typescript";
import { AccordionModule } from "primeng/accordion";
import { ContractCardComponent } from "./contract-card/contract-card.component";

@Component({
  selector: "app-contract",
  standalone: true,
  templateUrl: "./contract.component.html",
  imports: [
    CommonModule,
    AccordionModule,
    ContractCardComponent,
    TranslateModule,
    AddressMrhComponent,
    StatusCardComponent,
    TitlePjComponent,
    TitleSaComponent,
  ],
})
export class ContractComponent implements OnInit {
  @Input() openAccordion!: boolean;
  @Input() contracts!: Policy[];
  policyStatusConfig!: Record<string, StatusConfig>;
  branches = Branches;
  constructor(
    private readonly policyStatusService: PolicyStatusService,
    private readonly router: Router,
    private readonly offersTypeService: OffersTypeService
  ) {}

  ngOnInit() {
    this.policyStatusConfig = this.policyStatusService.getStatusConfig();
  }

  navigateToDetails(id: Guid) {
    const url = CONTRACTDETAILS.replace(ID_PARAM, id.toString());
    this.router.navigate([url]);
  }

  onKeyDown(event: KeyboardEvent, id: Guid) {
    if (event.key === "Enter" || event.key === " ") {
      this.navigateToDetails(id);
    }
  }

  isBranch(policy: Policy, branch: Branches): boolean {
    return this.offersTypeService.isPolicyBranch(policy, branch);
  }
}
